import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { addReport, toggleReaction } from 'actions/activities.js'
import { getActivities } from '../../../reducers/activities';
import ReportActivityModal from './ReportActivityModal.js';
import DatabaseService from '../../../services/DatabaseService';

class ReportActivityModalContainer extends Component {

    constructor(props) {
        super(props);
        this.busy = false; 
        this.state = {busy:false,reportId:-1,comment:''};
        if (this.props.activity.feedActionReport){ 
            this.state.reportId = (this.props.activity.feedActionReport.challengeReportReasonId>=0)?this.props.activity.feedActionReport.challengeReportReasonId:0;
            this.state.comment = this.props.activity.feedActionReport.comment;            
        }
        this.reports = this.props.challengeReportReason;
        this.onAddReport = this.onAddReport.bind(this);
        this.onChangeCommentReport = this.onChangeCommentReport.bind(this);
        this.onChangeReasonReport = this.onChangeReasonReport.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onChangeReasonReport(event,obj){
       // console.log(obj,(this.state.reportId===-1)?obj.value:-1)
        this.setState({reportId:obj.value});      

    }
    onChangeCommentReport(event,obj){
        this.setState({reportId:0,comment:obj.value});
    }
    onAddReport(){
        this.props.addReport(this.props.activity.id,this.state.reportId, this.state.comment)
        let result = DatabaseService.reportActivityReaction(this.props.activity.id,this.state.reportId, this.state.comment)
        if (result)
            this.props.onClose();
    }
    onClose() {
        this.props.onClose();
    }
    render() {
        return (
            <ReportActivityModal {...this.state}
                        valid = {(!this.props.activity.feedActionReport)}
                        activity = {this.props.activity}
                        onAddReport={this.onAddReport}
                        reportId = {this.state.reportId}
                        comment = {this.state.comment}
                        reports = {this.reports}
                        busy={this.state.busy}
                        onClose={this.onClose}
                        onChangeReasonReport={this.onChangeReasonReport}
                        onChangeCommentReport={this.onChangeCommentReport} />
        );
    }

}


function mapStateToProps(state, ownProps) {
    return {
            activities : getActivities(state.activities),
            end:state.activities.end,
            nextDate : state.activities.nextDate
        };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addReport: (activityId,reportId,comment) => dispatch(addReport(activityId,reportId,comment)),
        dispatch: dispatch
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(translate('newsfeed')(ReportActivityModalContainer));



// WEBPACK FOOTER //
// ./src/modules/newsfeed/modal/ReportActivityModalContainer.js